import assign from 'lodash/assign'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import merge from 'lodash/merge'
import set from 'lodash/set'
import Application from '../../Application'
import ScorocodeError from '../../utils/ScorocodeError'

export default class Document {
  private _id?: string
  private _initialAttributes: {}
  private _attributes: {}
  private _isDeleted: boolean

  constructor(
    public readonly app: Application,
    public readonly db: string,
    public readonly schema: string,
    public readonly collection: string,
    id?: string
  ) {
    this._initialAttributes = {}
    this._attributes = {}
    this._id = id
    this._isDeleted = false
  }

  get attributes(): {} {
    return cloneDeep(this._attributes)
  }

  set attributes(attributes: {}) {
    this._initialAttributes = cloneDeep(attributes)
    this._attributes = cloneDeep(attributes)
  }

  get id(): string | void {
    return this._id
  }

  get isDeleted(): boolean {
    return this._isDeleted
  }

  setAttributes(attributes: {}): this {
    this.attributes = attributes

    return this
  }

  merge(attributes: {}): this {
    merge(this._attributes, attributes)

    return this
  }

  assign(attributes: {}): this {
    assign(this._attributes, attributes)

    return this
  }

  set(field: string | string[], value: any): this {
    set(this._attributes, field, value)

    return this
  }

  get(field: string | string[]): any {
    return get(this._attributes, field)
  }

  save(force = false): Promise<this> {
    if (!this._id) {
      return this.app
        .client()
        .pgManager.insertDocument(this.db, this.schema, this.collection, this
          .attributes as any)
        .then((document) => {
          this._id = document.id

          this.attributes = document

          return this
        })
    }

    // есть изменения - сохраняем
    if (force || !isEqual(this._initialAttributes, this._attributes)) {
      return this.app
        .client()
        .pgManager.updateDocument(
          this.db,
          this.schema,
          this.collection,
          this._id,
          this.attributes as any
        )
        .then((document) => {
          this._id = document.id

          this.attributes = document

          return this
        })
    }

    return Promise.resolve(this)
  }

  delete(): Promise<this> {
    if (this._id && !this._isDeleted) {
      return this.app
        .client()
        .pgManager.deleteDocument(
          this.db,
          this.schema,
          this.collection,
          this._id
        )
        .then(() => {
          this._isDeleted = true

          return this
        })
    }

    return Promise.resolve(this)
  }

  sync(): Promise<this> {
    if (this._id) {
      return this.app
        .client()
        .pgManager.getDocumentById(
          this.db,
          this.schema,
          this.collection,
          this._id
        )
        .then((document) => {
          this._id = document.id

          this.attributes = document

          return this
        })
    }

    return Promise.resolve(this)
  }

  // must return unsubscribe function
  realSync(
    onChange: (document: Document) => void,
    onError: (error: ScorocodeError) => void
  ) {
    // todo
    onChange(this)
  }
}
